export type EventType =
    | 'call'
    | 'email'
    | 'messaggio'
    | 'meeting'
    | 'decisione'
    | 'follow_up'
    | 'chiuso';

export type EventStatus = 'open' | 'done' | 'cancelled';

export interface ClientEvent {
    id: string;
    client_id: string;
    event_type: EventType;
    title: string;
    notes: string | null;
    event_date: string; // ISO string
    parent_event_id: string | null;
    status: EventStatus;
    created_at: string;
    updated_at: string;
    created_by: string | null;
    // Joins
    reminders?: EventReminder[];
    children?: ClientEvent[]; // For hierarchy display
    creator?: EventCreator | null;
}

/** Profilo (ridotto) dell'utente che ha creato l'evento in timeline. */
export interface EventCreator {
    id: string;
    full_name: string | null;
    email: string;
}

export interface EventReminder {
    id: string;
    event_id: string;
    remind_at: string; // ISO string
    is_completed: boolean;
    created_at: string;
    created_by: string | null;
}

export const EVENT_TYPE_LABELS: Record<EventType, string> = {
    call: 'Chiamata',
    email: 'Email',
    messaggio: 'Messaggio',
    meeting: 'Meeting',
    decisione: 'Decisione',
    follow_up: 'Follow Up',
    chiuso: 'Chiuso',
};

export const EVENT_TYPE_ICONS: Record<EventType, string> = {
    call: 'phone',
    email: 'mail',
    messaggio: 'message-square',
    meeting: 'users',
    decisione: 'gavel',
    follow_up: 'arrow-right-circle',
    chiuso: 'x-circle',
};
